import { useQuery } from '@tanstack/react-query'
import {
  TutorDetailType,
  TutorStatType,
  TutorStudentsRes,
} from '@/types/student.type'
import { axiosInstance } from '@/lib/axios'

interface TutorStatProps {
  classId: string
  tutorId: string
  enable: boolean
}

interface TutorStudentsProps {
  classId: string
  page: number
  search: string
}

export const getTutorDetail = async (tutorId: string) => {
  return axiosInstance.get<TutorDetailType>(`/user/tutor/${tutorId}/classes`)
}

export const getTutorStat = async (classId: string, tutorId: string) => {
  return axiosInstance.get<TutorStatType>(
    `/user/tutor/${tutorId}/class/${classId}/info`
  )
}

export const getTutorStudents = async ({
  classId,
  page,
  search,
}: TutorStudentsProps) => {
  return axiosInstance.get<TutorStudentsRes>(
    `/user/tutor/class/${classId}/students?page=${page}&size=10&search=${search}`
  )
}

export const useGetTuTorDetail = (tutorId: string, enable: boolean) => {
  const { data, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ['tutorDetail', tutorId],
    queryFn: () => getTutorDetail(tutorId),
    enabled: !!tutorId && enable,
  })

  return {
    tutorDetail: data?.data,
    isLoadingTutorDetail: isLoading || isRefetching,
    refetchTutorDetail: refetch,
  }
}

export const useGetTutorStat = ({
  classId,
  tutorId,
  enable,
}: TutorStatProps) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['tutorStat', classId, tutorId, enable],
    queryFn: () => getTutorStat(classId, tutorId),
    enabled: !!classId && !!tutorId && enable,
  })

  return {
    tutorStat: data?.data,
    isLoadingStat: isLoading,
    refetchTutorStat: refetch,
  }
}

export const useGetTutorStudents = ({
  classId,
  page,
  search,
}: TutorStudentsProps) => {
  const { data, isLoading } = useQuery({
    queryKey: ['tutorStudent', classId, page, search],
    queryFn: () => getTutorStudents({ classId, page, search }),
    enabled: !!Number(classId),
  })

  return {
    tutorStudents: data?.data.data,
    meta: data?.data.meta,
    isLoadingTutorStudents: isLoading,
  }
}
